/**
 * Referral System Configuration
 * 
 * Centralized configuration for the referral/gifting system.
 * Adjust credit amounts, invitation limits, and other settings here.
 */

export const REFERRAL_CONFIG = {
  // Default number of invitations each user gets
  DEFAULT_INVITATION_LIMIT: 3,
  
  // Credit amounts (in cents)
  REFERRER_CREDIT_CENTS: 5000, // $50 for the person who refers
  NEW_MEMBER_CREDIT_CENTS: 2500, // $25 for the new member
  
  // Invitation code format
  INVITATION_CODE_PREFIX: 'HONEY',
  INVITATION_CODE_LENGTH: 8, // Total length including prefix and separator
  
  // Credit expiration (null = no expiration)
  CREDIT_EXPIRATION_DAYS: null as number | null,
  
  // Invitation expiration (null = no expiration)
  INVITATION_EXPIRATION_DAYS: null as number | null,
} as const;

/**
 * Generate the full signup URL with referral code
 */
export const generateReferralUrl = (code: string): string => {
  const baseUrl = typeof window !== 'undefined' 
    ? window.location.origin 
    : 'https://honeydone.com';
  return `${baseUrl}/signup?ref=${code}`;
};

/**
 * Format cents to dollar string
 */
export const formatCentsToUSD = (cents: number): string => {
  return `$${(cents / 100).toFixed(2)}`;
};

/**
 * Format cents to dollar string without decimals for whole amounts
 */
export const formatCentsToUSDShort = (cents: number): string => {
  const dollars = cents / 100;
  return dollars % 1 === 0 ? `$${dollars}` : `$${dollars.toFixed(2)}`;
};
